import NewsCard from "../Cards/NewsCard";
import ResourceCard from "../Cards/ResourceCard";
import MediaCard from "../Cards/MediaCard";

const List = ({posts, card}) => {

	const renderPosts = (posts) => {

		if (!posts) {
			return (
				<div className="error">
					<span>No results</span>
				</div>
			)
		}


		return posts.map((post) => {

			if (card === "NewsCard") {
				return (
					<NewsCard
						key={post.id}
						url={post.article_link}
						title={post.title}
						image={post.image}
						altText={post.alt_text}
						excerpt={post.excerpt}
						categories={post.categories}
					/>
				)
			}

			if (card === "ResourceCard") {
				return (
					<ResourceCard
						key={post.id}
						url={post.article_link}
						title={post.title}
						image={post.image}
						altText={post.alt_text}
						excerpt={post.excerpt}
						topics={post.topics}
						type={post.type}
						level={post.level}
					/>
				);
			}

			if (card === "MediaCard") {
				return (
					<MediaCard
						key={post.id}
						url={post.media_link}
						title={post.title}
						image={post.image}
						altText={post.alt_text}
						types={post.types}
						categories={post.categories}
					/>
				)
			}
		})
	}

	return (
		<div className="index-page__list">
			{renderPosts(posts)}
		</div>
	)
}

export default List;
